import AppStoreContext, { AppStore } from 'contexts/AppStoreContext';
import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import '../modals.css';
import ManageConnectionModalFC from './ManageConnectionModalFC';

interface Props extends RouteComponentProps {
  accountLabel: string;
  connectionId: string;
  isExpired: boolean;
  newConnection: boolean;
  providerType: string;
}

class ManageConnectionModal extends React.Component<Props, AppStore> {
  static modalClasses = {
    overlay: `modal__overlay`,
    content: `modal__window modal--sm`,
  };

  static modalStyles = {
    content: {
      width: '540px',
    },
  };

  static contextType = AppStoreContext;

  context!: React.ContextType<typeof AppStoreContext>;

  render(): React.ReactNode {
    const {
      providerType,
      connectionId,
      newConnection,
      accountLabel,
      isExpired,
    } = this.props;

    return (
      <ManageConnectionModalFC
        providerType={providerType}
        connectionId={connectionId}
        accountLabel={accountLabel}
        isExpired={isExpired}
        newConnection={newConnection}
      />
    );
  }
}

export default withRouter(ManageConnectionModal);
